export { default } from './mergeSlotProps';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/mergeSlotProps/index.js
// module id = 757
// module chunks = 22